var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Status, useSession } from '@lendi/lala-react';
import React from 'react';
import { withChatAnalytics } from '../../analytics';
import { withErrorProvider } from '../../providers/ErrorProvider/withErrorProvider';
import { withSafetyNetProvider } from '../../providers/SafetyNetProvider';
import { SmartChat } from './SmartChat';
import { ThreadsPanel } from './ThreadsPanel';
var ChatComponentInner = function (props) {
    var session = useSession();
    // chat window open
    // unauthenticated
    // load smart chat
    if (session.status !== Status.Authenticated) {
        return React.createElement(SmartChat, null);
    }
    // else load chat threads
    return React.createElement(ThreadsPanel, __assign({}, props));
};
var ChatComponent = withErrorProvider(withChatAnalytics(withSafetyNetProvider(ChatComponentInner)));
export default ChatComponent;
//# sourceMappingURL=index.js.map